import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SYSTEM_FORM_PAGES, SystemCard } from './system-form-pages';

/**
 * A Settings page cut from twin-ci System Settings (system-form-pages.ts): the page heading and its
 * sections, each an app-system-card with its own Save. The page comes from route data.
 */
@Component({
    selector: 'app-system-form',
    templateUrl: './system-form.component.html',
    styles: [':host { display: block; }']
})
export class SystemFormComponent implements OnInit, OnDestroy {
    key = '';
    cards: SystemCard[] = [];
    private subscription: Subscription;

    constructor(private route: ActivatedRoute) { }

    ngOnInit() {
        this.subscription = this.route.data.subscribe(data => {
            this.key = data.page;
            const page = SYSTEM_FORM_PAGES[this.key];
            this.cards = 'cards' in page ? page.cards : [page];
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
